"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var Caret_1 = __importDefault(require("atomicComponents/atoms/Icons/Caret"));
var MenuItem_1 = __importDefault(require("./MenuItem"));
var PREFIX = 'Select';
var classes = {
    customSelect: "".concat(PREFIX, "-customSelect"),
};
var StyledFormControl = (0, styles_1.styled)(material_1.FormControl)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.customSelect)] = {
            textTransform: 'none',
            fontWeight: theme.typography.fontWeightRegular,
            '&.MuiSelect-select:focus': {
                backgroundColor: theme.palette.common.white,
            },
            '&.MuiSelect-icon': {
                display: 'none',
            },
            '&.MuiSelect-select.MuiSelect-select': {
                paddingRight: 0,
            },
        },
        _b);
});
var Select = function (_a) {
    var _b = _a.input, name = _b.name, value = _b.value, onChange = _b.onChange, restInput = __rest(_b, ["name", "value", "onChange"]), meta = _a.meta, options = _a.options, label = _a.label, _c = _a.icon, icon = _c === void 0 ? true : _c, rest = __rest(_a, ["input", "meta", "options", "label", "icon"]);
    return ((0, jsx_runtime_1.jsxs)(StyledFormControl, __assign({ fullWidth: true, color: "secondary", variant: "standard" }, { children: [(0, jsx_runtime_1.jsx)(material_1.InputLabel, __assign({ htmlFor: name }, { children: label })), (0, jsx_runtime_1.jsx)(material_1.Select, __assign({}, rest, { inputProps: restInput, IconComponent: function () { return icon && (0, jsx_runtime_1.jsx)(Caret_1.default, {}); }, name: name, value: value, onChange: function (event) { return onChange(event.target.value); }, error: meta.error, classes: { select: classes.customSelect }, variant: "standard" }, { children: options.map(function (option) { return ((0, jsx_runtime_1.jsx)(MenuItem_1.default, __assign({ value: option.value }, { children: option.label }), option.value)); }) }))] })));
};
exports.default = Select;
